module.exports = __webpack_public_path__ + "img/vertical_3_3_1.d4d416b3.png";